import { Box, Typography, Stack } from '@mui/material';
import React, { FC } from 'react';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

export const AccountApprovedCard: FC = () => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
      <Box
        sx={{
          width: '100%',
          maxWidth: 700,
          textAlign: 'center',
          boxShadow: '2px 2px 10px 0px #0000000D',
          borderRadius: 2,
          p: 4,
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Box
            sx={{
              p: 1.5,
              bgcolor: '#F2F4F8',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 64,
              height: 64,
            }}
          >
            <AccountBalanceIcon sx={{ color: '#115398', fontSize: 32 }} />
          </Box>

          <Typography variant="h4" fontWeight={600}>
            Última etapa
          </Typography>

          <Typography>Estamos aguardando a assinatura do Contrato de Abertura de Conta.</Typography>

          <Typography>
            Em até <b>15 minutos</b> o seguinte sócio/representante irá receber um e-mail para finalizar o procedimento e realizar a
            biometria:
          </Typography>

          <Box>
            Após a assinatura você já vai conseguir acessar a Conta Digital e poderá aproveitar todas as funcionalidades. Na tela Resumo
            você poderá encontrar o Manual de Uso e outros documentos relacionados à sua conta.
          </Box>

          <Typography variant="body2" color="text.secondary" mb={0} pb={0}>
            Em caso de dúvidas, estamos à disposição.
          </Typography>

          <Typography variant="body2" color="text.secondary" mt={0} pt={0}>
            Equipe Torqi
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};
